import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  total_visitas = '0';
  url = '';
  fecha_actual;
  anio_actual;

  constructor(private http: HttpClient, public global: AppComponent) { 
    this.url = global.url;
    this.fecha_actual = new Date();
    this.anio_actual = this.fecha_actual.getFullYear();
    //this.getVisitas();
  }

  ngOnInit() { }
  /*
  getVisitas(){
    this.http.get(this.url+'pagopredial/tramite/total_visitas')
    .subscribe((result: any) => {
      if (result['status']===false) {
        this.total_visitas = '0';
      } else {
        this.total_visitas = result['total_visitas'][0]['total_visitas'];
      }
    });
  }
  */
}